import { VariaveisAmbiente } from 'config';
import { ComissaoPostModel } from 'model/api/gestao/comissao/comissao-post-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function usePostComissao() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postComissao = useCallback(
        (model: ComissaoPostModel) =>
            invocarApi({
                url: `/${VariaveisAmbiente.apiVersion}/comissao`,
                method: 'POST',
                data: model,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postComissao,
    };
}
